import { render, staticRenderFns } from "./Mortgagepayments.vue?vue&type=template&id=1723e6db"
import script from "./Mortgagepayments.vue?vue&type=script&lang=js"
export * from "./Mortgagepayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports